import axios from "axios";

export default class FicherosService {
    static subirFichero(fichero) {
        let formData = new FormData();
        formData.append("fichero", fichero);
        
        return axios.post( `/api/subir-indicadores`,  formData,   {
            headers: {
              "Content-Type": "multipart/form-data"
            }
        }).catch(err => console.err(err));
    } 
}